<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  document.addEventListener('DOMContentLoaded', function() {
    var descriptionTab = document.querySelector('[data-tab="description-tab"]');
    var descriptionContent = document.querySelector('.description-content'); // Tab içeriğini temsil eden sınıf.

    if (descriptionContent && descriptionContent.innerHTML.trim() === '') {
        if (descriptionTab) descriptionTab.style.display = 'none';
        descriptionContent.style.display = 'none';
    }
});




